const zh = {
  // Navbar
  "nav.home": "首页",
  "nav.creators": "创作者",
  "nav.campaigns": "活动",
  "nav.rewards": "奖励",
  "nav.community": "社区",
  "nav.pricing": "定价",
  "nav.registerCreator": "注册创作者",
  "nav.login": "登录",
  "nav.start": "立即开始",
  "nav.mypage": "我的主页",
  "nav.settings": "设置",
  "nav.logout": "退出登录",
  "nav.tokens": "代币",
  "nav.brands": "品牌",

  // Hero Section
  "hero.joinCampaign": "参与活动",
  "hero.exploreCreators": "探索创作者",

  // Service Intro
  "service.howItWorks": "使用方式",
  "service.title": "从K-POP到韩剧、电影、漫画",
  "service.titleHighlight": "全娱乐IP创作平台",
  "service.desc": "CreatorVerse将K-POP偶像、影视制作公司、电影公司和网络漫画工作室的官方IP与AI技术连接，让每位粉丝都能创作自己的作品。",
  "service.step.selectIP": "选择IP",
  "service.step.selectIP.desc": "从K-POP、韩剧、电影或漫画中选择您喜欢的IP",
  "service.step.joinCampaign": "参与活动",
  "service.step.joinCampaign.desc": "选择MV、剧情场景、海报等活动类型",
  "service.step.aiCreate": "AI创作",
  "service.step.aiCreate.desc": "使用AI工具打造属于自己的独特作品",
  "service.step.shareReward": "分享获奖",
  "service.step.shareReward.desc": "在社区分享并赚取XP奖励",
  "service.cta.title": "立即成为粉丝创作者",
  "service.cta.desc": "K-POP、韩剧、电影、漫画 — 用您喜欢的IP通过AI创作专属内容",
  "service.cta.startCampaign": "开始活动",
  "service.cta.exploreIP": "探索IP",

  // Latest Campaigns
  "latest.title": "立即可参与的",
  "latest.titleHighlight": "最新娱乐活动",
  "latest.viewAll": "全部活动",
  "latest.viewAllCampaigns": "查看全部活动",
  "latest.filter.all": "全部",
  "latest.filter.kpop": "K-POP",
  "latest.filter.drama": "韩剧",
  "latest.filter.film": "电影",
  "latest.filter.webtoon": "漫画",
  "latest.participation": "参与率",
  "latest.participants": "人",

  // Footer
  "footer.platform": "平台",
  "footer.exploreIdols": "探索偶像",
  "footer.campaigns": "活动",
  "footer.community": "社区",
  "footer.pricing": "定价",
  "footer.createCampaign": "创建活动",
  "footer.artist": "艺人",
  "footer.artistRegister": "艺人注册",
  "footer.ipManagement": "IP管理",
  "footer.campaignCreate": "发布活动",
  "footer.fanStats": "粉丝数据",
  "footer.support": "客服",
  "footer.newsletter": "获取最新消息",
  "footer.newsletterDesc": "接收最新活动和偶像新闻",
  "footer.emailPlaceholder": "邮箱地址",
  "footer.subscribed": "订阅成功！",
  "footer.startFree": "免费开始",
  "footer.terms": "服务条款",
  "footer.privacy": "隐私政策",
  "footer.copyright": "© 2026 CreatorVerse. 版权所有。",

  // Campaigns page
  "campaigns.breadcrumb.home": "首页",
  "campaigns.breadcrumb.campaigns": "活动",
  "campaigns.hero.title": "探索所有艺人的",
  "campaigns.hero.titleHighlight": "精彩活动",
  "campaigns.hero.desc": "挑战艺人们发布的活动，用AI制作专属视频。",
  "campaigns.hero.createVideo": "制作视频",
  "campaigns.filterByArtist": "按艺人筛选",
  "campaigns.all": "全部",
  "campaigns.noResults": "没有搜索结果",
  "campaigns.resetFilters": "重置筛选",
  "campaigns.total": "共",
  "campaigns.totalSuffix": "个活动",
  "campaigns.searchPlaceholder": "按活动标题搜索...",
  "campaigns.allArtists": "全部艺人",
  "campaigns.allDifficulty": "全部难度",
  "campaigns.difficulty.easy": "入门",
  "campaigns.difficulty.medium": "中级",
  "campaigns.difficulty.hard": "高级",
  "campaigns.sort.latest": "最新",
  "campaigns.sort.popular": "最热门",
  "campaigns.sort.reward": "奖励最高",
  "campaigns.sort.deadline": "即将截止",
  "campaigns.progress": "进度",
  "campaigns.participate": "人参与",
  "campaigns.startCampaign": "开始活动",

  // Login
  "login.title": "登录",
  "login.welcome": "欢迎来到CreatorVerse！",
  "login.google": "使用Google继续",
  "login.kakao": "使用Kakao继续",
  "login.orEmail": "或使用邮箱登录",
  "login.email": "邮箱",
  "login.password": "密码",
  "login.forgotPassword": "忘记密码？",
  "login.submit": "登录",
  "login.loading": "登录中...",
  "login.noAccount": "还没有账号？",
  "login.signup": "注册",
  "login.testHint": "测试：任意邮箱（含@）+ 8位以上密码",
  "login.error.default": "登录失败",

  // Signup
  "signup.step.account": "账号信息",
  "signup.step.profile": "个人资料",
  "signup.accountInfo": "填写账号信息",
  "signup.email": "邮箱 *",
  "signup.password": "密码 *",
  "signup.passwordConfirm": "确认密码 *",
  "signup.next": "下一步",
  "signup.complete": "完成注册",
  "signup.hasAccount": "已有账号？",
  "signup.login": "登录",
  "signup.profileSetup": "粉丝资料设置",
  "signup.nickname": "昵称 *",
  "signup.nicknamePlaceholder": "在社区中使用的昵称",
  "signup.favoriteGroup": "最爱组合（可选）",
  "signup.agreeTerms": " *",
  "signup.agreeMarketing": "同意接收营销信息（可选）",
  "signup.terms": "服务条款",
  "signup.privacy": "隐私政策",
  "signup.and": "及",
  "signup.done.title": "注册成功！",
  "signup.done.plan": "套餐已激活",
  "signup.done.tokenGranted": "代币已发放！",
  "signup.done.joinCampaign": "参与活动",
  "signup.done.goHome": "返回首页",
  "signup.changePlan": "更改套餐",
  "signup.selectedPlan": "已选套餐",
  "signup.tokensPerMonth": "代币/月",
  "signup.aiUsage": "用于AI视频生成",

  // Common
  "common.language": "语言",
};

export default zh;
